export default __webpack_public_path__ + "static/media/single_box.ea805ac7.png";